<template>
  <div class="physical-activity">
    <div class="d-flex justify-space-between ">
      <h2 class="mb-8">{{ $ucfirst($t("screens.startMovingSettingsScreen", { catalog: 'app_mobile' })) }}</h2>
      <level-of-guidance-indicator
        behaviourComponent="STARTMOVING"
      ></level-of-guidance-indicator>
    </div>
    <p-a-button-line />
    <router-view></router-view>
    <discussion-step-nav-buttons
      :nextRoutes="nextDiscussionStep"
      :prevRoutes="prevDiscussionStep"
    >
    </discussion-step-nav-buttons>
  </div>
</template>

<script>
import DiscussionStepNavButtons from '../../../components/Parts/DiscussionStepNavButtons.vue';
import PAButtonLine from "../../../components/Parts/PAButtonLine";
import LevelOfGuidanceIndicator from "../../../components/Parts/LevelOfGuidanceIndicator.vue";

/**
 * Component PatientOverviewPA.vue
 *
 * @module PatientOverviewPA
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.7] app/src/APP_DASHBOARD/templates/views/Patient/PA/PatientOverviewPA.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "PatientOverviewPA",
  props: ['nextDiscussionStep', 'prevDiscussionStep'],
  components: {
    PAButtonLine,
    LevelOfGuidanceIndicator,
    DiscussionStepNavButtons
  },
};
</script>

<style lang="scss">
</style>
